import { UserAccessRight } from '../../../general/model';
import { createAction } from '@reduxjs/toolkit';

export const modalOpened = createAction<{ nodeID: number }>(
  'creativeHub/permissionModal/MODAL_OPENED',
);
export const modalClosed = createAction<void>('creativeHub/permissionModal/MODAL_CLOSED');
export const modalCloseUiEvent = createAction<void>(
  'creativeHub/permissionModal/MODAL_CLOSE_UI_EVENT',
);
export const permissionChanged = createAction<{ permission: UserAccessRight; checked: boolean }>(
  'creativeHub/permissionModal/PERMISSION_CHANGED',
);
export const usersChanged = createAction<{ users: number[] }>(
  'creativeHub/permissionModal/USERS_CHANGED',
);
export const loadingChanged = createAction<{ isLoading: boolean }>(
  'creativeHub/permissionModal/LOADING_CHANGED',
);
export const closeButtonClicked = createAction<void>(
  'creativeHub/permissionModal/CLOSE_BUTTON_CLICKED',
);
export const applyButtonClicked = createAction<void>(
  'creativeHub/permissionModal/APPLY_BUTTON_CLICKED',
);
export const applyPermissionsStarted = createAction<void>(
  'creativeHub/permissionModal/APPLY_PERMISSIONS_STARTED',
);
export const applyPermissionsSuccess = createAction<{ result: any }>(
  'creativeHub/permissionModal/APPLY_PERMISSIONS_SUCCESS',
);
export const applyPermissionsError = createAction<{ error: any }>(
  'creativeHub/permissionModal/APPLY_PERMISSIONS_ERROR',
);
export const applyBulkPermissionsStarted = createAction<void>(
  'creativeHub/permissionModal/APPLY_BULK_PERMISSIONS_STARTED',
);
export const applyBulkPermissionsFinished = createAction<void>(
  'creativeHub/permissionModal/APPLY_BULK_PERMISSIONS_FINISHED',
);
